<!-- <template>
    <zen-one title="Dashboard:: Pendidikan" :crumbs="crumbs"> </zen-one>
</template>

<script>
export default {
    data() {
        return {
            crumbs: [
                { label: "iHasil", route: "/sitemap" },
                { label: "Pendidikan", route: "/pendidikan/dashboard" },
            ],
        };
    },
};
</script> -->

<template>
    <zen-one :showuserinfo="false" title="Sistem Hasil Bersepadu Kedah (iHasil)" :crumbs="crumbs">



        <z-page title="Dashboard Pendidikan" class="mt3">

    <w-flex wrap class="mt3" background="royalblue">
      <template v-for="item in datas">
        <div class="xs4" >
          <inertia-link :href="$route('pendidikan.index')+'?lkp_pendidikan_status_id='+item.value">
          <z-dashboard-item
            class="box sh1 ml1 mb1 "
            icon="fal fa-file"
            icon-color="black-dark1"
            subtitle=''>
            <span class="title black"><b>{{item.label}}</b></span><br>
            <w-tag color="pink" bg-color="light-blue-5" class="sh1">
                <w-icon class="mr1" sm>
                  fal fa-calendar
                </w-icon>
                <span class="black">{{item.count}}</span>
            </w-tag><br>

          </z-dashboard-item>
          </inertia-link>
        </div>
      </template><br><br>
    </w-flex>

      </z-page>



    </zen-one>
</template>

<script>
import { reactive } from 'vue'
// import ZenOne from '@/Shared/ZenOne'
import ZResource from '@/Modules/z-resource-service'


export default {
  extends: ZResource,
  components: {
    // ZenOne
  },
  props: {
    //
  },
  data() {
    return {
        resourceurl: this.service_tunggakan +'lookup/lkp_pendidikan_status',
        reload: true,
        crumbs: [
            // { label: this.$page.props.app_name, route: '/sitemap' },
        { label: 'iHasil', route: '/ihasil' },
        { label: 'Pendidikan', route: '/pendidikan' },
        { label: 'Dashboard', route: '/pendidikan/dashboard' },
          ],
          form: {
            // id: 0,
            no: '',
            no_dokumen: '',
            },
        }
  },
  methods: {

  },
  watch: {

  },
  mounted() {
    // override default setting
    this.dialog.width = 500

  },
}
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>
